import { Dropdown, Space } from 'antd'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { icons } from '../../assets'
import { Button, CustomModal } from '../../components'
import { ChangeStatusEnterprise, getAllEnterpiseds } from '../../redux/AdminInmersys/thunks'

import { PrivatePath } from '../../routers/paths'
import { MenuFooter } from '../common'

export const MenuAdmin = () => {
    const dispatch = useDispatch()
    const { enterprises } = useSelector((state) => state.adminInmersys);
    useEffect(() => {
        const onGetData = async () => {
            await dispatch(getAllEnterpiseds())
        }
        onGetData()
    }, [dispatch])


    return (
        <div className="z-20 pt-16 fixed top-0 left-0 w-[208px] h-full bg-white flex flex-col shadow-xl">
            <div className='w-full h-4/6  pt-8 px-4'>
                {
                    enterprises.map((element, x) =>
                        <ElementMenu key={x} proyectName={element.name} id={element._id} />
                    )
                }
            </div>
            <div className='w-full h-2/6  flex items-end'>
                <MenuFooter purple={true} />
            </div>
        </div>
    )
}

const ElementMenu = ({ proyectName = 'none', id = '00000000' }) => {
    const [menuOpen, setMenuOpen] = useState(false)
    const [modalDelete, setModalDelete] = useState(false)
    const navigate = useNavigate()

    const dispatch = useDispatch()

    const onDeleteEnterpise = () => {
        dispatch(ChangeStatusEnterprise(id))
    }

    return (
        <div className='w-full py-2'>
            <div className='flex justify-between cursor-pointer'>
                <img onClick={() => setMenuOpen(!menuOpen)} className={menuOpen ? `` : `transform rotate-180`} src={icons.arrowMwnuState} alt="arrow" />
                <p onClick={() => setMenuOpen(!menuOpen)} className='text-lg text-1B1464 font-medium'>{proyectName}</p>
                <Dropdown menu={{
                    items: [{
                        label: (
                            <span>Eliminar empresa</span>
                        ),
                        key: '0',
                        onClick: () => setModalDelete(true)
                    },]
                }}>
                    <Space>
                        <img src={icons.union} alt="icon menu more options" />
                    </Space>
                </Dropdown>

            </div>
            {
                menuOpen &&
                <div className='w-full pt-2'>
                    <p onClick={() => { navigate(`${id}/${PrivatePath.dashboardVrl}`) }}
                        className='hover:bg-blue-100 w-full pl-4 cursor-pointer py-2 text-sm text-[#1B1464] font-normal '>Dashboard</p>
                    <p onClick={() => { navigate(`${id}/${PrivatePath.tableVrl}`) }} className='hover:bg-blue-100 w-full pl-4 cursor-pointer py-2 text-sm text-[#1B1464] font-normal '>Tabla</p>
                    <p onClick={() => { navigate(`${id}/${PrivatePath.analyticsVrl}`) }} className='hover:bg-blue-100 w-full pl-4 cursor-pointer py-2 text-sm text-[#1B1464] font-normal '>Analiticas</p>
                </div>
            }
            <CustomModal isVisible={modalDelete} close={() => { setModalDelete(false) }} title="¿Eliminar empresa?" width={430} height={196} >
                <div className="w-full h-full px-4 py-2">
                    <div className="text-base text-[#9a9a9a] h-24">
                        Si eliminas esta empresa, se eliminará de forma permanente la información y ya no podrás acceder a ella.
                    </div>
                    <div className="w-full flex justify-end items-center">
                        <Button
                            text="Cancelar"
                            isPrincipal={false}
                            onClick={() => {
                                setModalDelete(false)
                            }}
                        />
                        <div className="w-4"></div>
                        <Button
                            text='Eliminar'
                            isPrincipal={true}
                            onClick={(e) => { onDeleteEnterpise() }}
                        />
                    </div>
                </div>
            </CustomModal>
        </div>
    )
}

export default MenuAdmin